/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Faq_Q7Inputs */

const en_sorter_faq_q7 = /** @type {(inputs: Sorter_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I sort array elements too?`)
};

const ko_sorter_faq_q7 = /** @type {(inputs: Sorter_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배열 요소도 정렬할 수 있나요?`)
};

const ja_sorter_faq_q7 = /** @type {(inputs: Sorter_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配列要素も並べ替えられますか`)
};

/**
* | output |
* | --- |
* | "Can I sort array elements too?" |
*
* @param {Sorter_Faq_Q7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_faq_q7 = /** @type {((inputs?: Sorter_Faq_Q7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Faq_Q7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_faq_q7(inputs)
	if (locale === "ko") return ko_sorter_faq_q7(inputs)
	return ja_sorter_faq_q7(inputs)
});